export interface UserCarrierScac {
  userCarrierScacId: string;
  userId: string;
  carrierId: string;
  scac: string;
}
